var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 120 120",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1363DF;}\r\n\t.st1{fill:#DFF6FF;}\r\n\t.st2{fill:#06283D;}\r\n\t.st3{fill:#47B5FF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 18.6,
    cy: 64.9,
    rx: 6.6,
    ry: 6.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -40.471 32.1518)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 101.4,
    cy: 64.9,
    rx: 6.6,
    ry: 6.6,
    transform: "matrix(0.9732 -0.2298 0.2298 0.9732 -12.2044 25.0397)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.4,52.8h-5.6C90.8,35.8,77,22,60,22c-17,0-30.8,13.8-30.8,30.8h-5.6c0-20.1,16.3-36.4,36.4-36.4    S96.4,32.7,96.4,52.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.3,101.4c-2.4,0-4-0.1-4.2-0.1l0.2-2.2c0.2,0,22.9,1.7,25.6-7.7c3-10.4,1.5-21.4,1.5-21.5l2.2-0.3    C94.7,70,96.2,81.1,93,92C90.5,100.3,76.5,101.4,69.3,101.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.3,103.6h-6.1c-2,0-3.6-1.6-3.6-3.6l0,0c0-2,1.6-3.6,3.6-3.6h6.1c2,0,3.6,1.6,3.6,3.6l0,0   C71.9,102,70.3,103.6,68.3,103.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.2,50.9L25.2,50.9c-5.1,0-9.3,4.2-9.3,9.3v10.8c0,5.1,4.2,9.3,9.3,9.3h0c4.3,0,7.8-3.5,7.8-7.8V58.6    C32.9,54.3,29.5,50.9,25.2,50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94.8,50.9L94.8,50.9c-4.3,0-7.8,3.5-7.8,7.8v13.8c0,4.3,3.5,7.8,7.8,7.8h0c5.1,0,9.3-4.2,9.3-9.3V60.1    C104.1,55,99.9,50.9,94.8,50.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.3fd9c086b635668302f2c0a0cb02a8e7.svg";
export { ForwardRef as ReactComponent };